export default "__VITE_ASSET__BTM8U_XC__"